import MediaLibrary from '../MediaLibrary';

const BrandMediaPage = () => <MediaLibrary />;

export default BrandMediaPage;
